import React, { useState, useEffect } from 'react'
import {
  getConfig, updateConfig,
  listSubmissions, getSubmission, exportSubmissions,
  deleteSubmission, shareSubmission,
  formatFileSize, formatTimestamp, DEFAULT_CONFIG
} from '../services/api'

// ===== SVG Icons =====
const Icons = {
  Dashboard: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/></svg>,
  Settings: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>,
  Folder: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>,
  Download: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>,
  ArrowLeft: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="19" y1="12" x2="5" y2="12"/><polyline points="12 19 5 12 12 5"/></svg>,
  ArrowRight: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="9 18 15 12 9 6"/></svg>,
  Clock: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>,
  X: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>,
  Plus: () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>,
  Trash: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>,
  MoveUp: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="18 15 12 9 6 15"/></svg>,
  MoveDown: () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="6 9 12 15 18 9"/></svg>,
  Logout: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>,
  Play: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="5 3 19 12 5 21 5 3"/></svg>,
  Image: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/></svg>,
  File: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>,
  Eye: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>,
  Share: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="18" cy="5" r="3"/><circle cx="6" cy="12" r="3"/><circle cx="18" cy="19" r="3"/><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"/><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"/></svg>,
  Copy: () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>,
}



// ===== TOAST NOTIFICATION =====
function Toast({ message, type, onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 3500)
    return () => clearTimeout(t)
  }, [onClose])

  return <div className={`toast toast--${type}`}>{message}</div>
}


// ===== ADMIN DASHBOARD =====
function DashboardView({ config, submissions, onViewSubmission }) {
  const totalSize = submissions.reduce((acc, s) => acc + (s.logoFileSize || 0) + (s.videoFileSize || 0), 0)
  const deadline = new Date(config.submissionDeadline)
  const now = new Date()
  const daysLeft = Math.max(0, Math.ceil((deadline - now) / (1000 * 60 * 60 * 24)))

  return (
    <div>
      <h2>Dashboard</h2>
      <div className="stats-row">
        <div className="stat-card">
          <div className="stat-card__value">{submissions.length}</div>
          <div className="stat-card__label">Total Submissions</div>
        </div>
        <div className="stat-card">
          <div className="stat-card__value">{formatFileSize(totalSize)}</div>
          <div className="stat-card__label">Storage Used</div>
        </div>
        <div className="stat-card">
          <div className="stat-card__value" style={{ color: daysLeft > 0 ? 'var(--sax-green)' : 'var(--sax-red)' }}>
            {daysLeft > 0 ? daysLeft : 'Closed'}
          </div>
          <div className="stat-card__label">{daysLeft > 0 ? 'Days Until Deadline' : 'Submissions Closed'}</div>
        </div>
        <div className="stat-card">
          <div className="stat-card__value" style={{ color: config.submissionsOpen ? 'var(--sax-green)' : 'var(--sax-red)' }}>
            {config.submissionsOpen ? 'Open' : 'Closed'}
          </div>
          <div className="stat-card__label">Form Status</div>
        </div>
      </div>

      {/* Recent Submissions */}
      <div className="admin-card">
        <h3>Recent Submissions</h3>
        {submissions.length === 0 ? (
          <p style={{ color: 'var(--sax-gray-500)', fontSize: '0.9rem' }}>No submissions yet.</p>
        ) : (
          <ul className="submission-list">
            {submissions.slice(0, 10).map((s, i) => (
              <li key={i} className="submission-item" onClick={() => onViewSubmission(s)}>
                <span className="submission-item__org">{s.orgName || 'Unknown'}</span>
                <span className="submission-item__contact">{s.contactEmail || ''}</span>
                <span className="submission-item__date">{s.submittedAt ? formatTimestamp(s.submittedAt) : ''}</span>
                <span className="submission-item__arrow"><Icons.ArrowRight /></span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}


// ===== CONFIG EDITOR =====
function ConfigEditor({ config, onSave }) {
  const [draft, setDraft] = useState(config)
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    // Merge with DEFAULT_CONFIG so any new fields added since last save
    // are pre-populated rather than blank
    setDraft({ ...DEFAULT_CONFIG, ...config })
  }, [config])

  const update = (key, value) => setDraft(prev => ({ ...prev, [key]: value }))

  const updateQuestion = (index, value) => {
    const qs = [...(draft.videoQuestions || [])]
    qs[index] = value
    setDraft(prev => ({ ...prev, videoQuestions: qs }))
  }

  const addQuestion = () => {
    setDraft(prev => ({ ...prev, videoQuestions: [...(prev.videoQuestions || []), ''] }))
  }

  const removeQuestion = (index) => {
    setDraft(prev => ({
      ...prev,
      videoQuestions: prev.videoQuestions.filter((_, i) => i !== index)
    }))
  }

  const moveQuestion = (index, dir) => {
    const qs = [...draft.videoQuestions]
    const newIndex = index + dir
    if (newIndex < 0 || newIndex >= qs.length) return
    ;[qs[index], qs[newIndex]] = [qs[newIndex], qs[index]]
    setDraft(prev => ({ ...prev, videoQuestions: qs }))
  }

  const updatePrize = (index, key, value) => {
    const ps = [...(draft.prizes || [])]
    ps[index] = { ...ps[index], [key]: value }
    setDraft(prev => ({ ...prev, prizes: ps }))
  }

  const addPrize = () => {
    setDraft(prev => ({
      ...prev,
      prizes: [...(prev.prizes || []), { place: '', description: '' }]
    }))
  }

  const removePrize = (index) => {
    setDraft(prev => ({
      ...prev,
      prizes: prev.prizes.filter((_, i) => i !== index)
    }))
  }

  // Form fields editor
  const updateField = (index, key, value) => {
    const fields = [...(draft.formFields || [])]
    fields[index] = { ...fields[index], [key]: value }
    setDraft(prev => ({ ...prev, formFields: fields }))
  }

  const addField = () => {
    const id = 'custom_' + Date.now()
    setDraft(prev => ({
      ...prev,
      formFields: [...(prev.formFields || []), { id, label: 'New Field', type: 'text', required: false }]
    }))
  }

  const removeField = (index) => {
    setDraft(prev => ({
      ...prev,
      formFields: prev.formFields.filter((_, i) => i !== index)
    }))
  }

  const handleSave = async () => {
    setSaving(true)
    try {
      await onSave(draft)
    } finally {
      setSaving(false)
    }
  }

  // Convert deadline UTC string to EST/EDT for datetime-local input
  const deadlineLocal = (() => {
    try {
      const d = new Date(draft.submissionDeadline)
      return d.toLocaleString('sv', { timeZone: 'America/New_York' }).replace(' ', 'T').slice(0, 16)
    } catch { return '' }
  })()

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'var(--space-xl)' }}>
        <h2>Site Configuration</h2>
        <button className="btn btn--primary" onClick={handleSave} disabled={saving}>
          {saving ? 'Saving...' : 'Save Changes'}
        </button>
      </div>

      {/* General Settings */}
      <div className="admin-card">
        <h3>General Settings</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
          <div className="form-group">
            <label>Award Year</label>
            <input type="text" value={draft.awardYear || ''} onChange={(e) => update('awardYear', e.target.value)} />
          </div>
          <div className="form-group">
            <label>Award Title</label>
            <input type="text" value={draft.awardTitle || ''} onChange={(e) => update('awardTitle', e.target.value)} />
          </div>
          <div className="form-group">
            <label>Theme</label>
            <input type="text" value={draft.theme || ''} onChange={(e) => update('theme', e.target.value)} />
          </div>
          <div className="form-group">
            <label>Theme Definition</label>
            <input type="text" value={draft.themeDefinition || ''} onChange={(e) => update('themeDefinition', e.target.value)} />
          </div>
        </div>
        <div className="form-group">
          <label>Hero Section — Image or Text</label>
          <p style={{ fontSize: '0.85rem', color: 'var(--sax-gray-500)', marginBottom: '0.75rem' }}>
            Upload a photo to replace the entire hero area with an image. Leave empty to show the text title, subtitle, and theme.
          </p>
          <label style={{
            display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
            cursor: 'pointer', fontSize: '0.85rem', fontWeight: 500,
            color: 'var(--sax-gold-dark)', fontFamily: 'var(--font-body)'
          }}>
            <input
              type="file"
              accept=".png,.jpg,.jpeg,.webp,.gif"
              style={{ display: 'none' }}
              onChange={(e) => {
                const file = e.target.files?.[0]
                if (!file) return
                const reader = new FileReader()
                reader.onload = (ev) => update('heroImageUrl', ev.target.result)
                reader.readAsDataURL(file)
                e.target.value = ''
              }}
            />
            📁 Upload hero image
          </label>
          <span style={{ fontSize: '0.75rem', color: 'var(--sax-gray-500)', marginLeft: '0.5rem' }}>PNG, JPG, WebP</span>
          {draft.heroImageUrl ? (
            <div style={{ marginTop: '0.75rem' }}>
              <p style={{ fontSize: '0.75rem', color: 'var(--sax-gray-500)', marginBottom: '0.4rem' }}>Preview (as it appears on the form page):</p>
              <div style={{ background: 'var(--sax-navy)', borderRadius: 'var(--radius-lg)', padding: 'var(--space-xl) 0' }}>
                <div style={{ maxWidth: '1036px', margin: '0 auto', padding: '0 var(--space-xl)' }}>
                  <div style={{ height: '480px', overflow: 'hidden', borderRadius: 'var(--radius-lg)' }}>
                    <img src={draft.heroImageUrl} alt="Hero preview" style={{ width: '100%', height: '100%', objectFit: 'cover', objectPosition: 'center', display: 'block' }} />
                  </div>
                </div>
              </div>
              <button
                onClick={() => update('heroImageUrl', '')}
                style={{ marginTop: '0.5rem', background: 'none', border: 'none', color: 'var(--sax-red)', cursor: 'pointer', fontSize: '0.85rem', padding: 0 }}
              >
                ✕ Remove image (revert to text)
              </button>
            </div>
          ) : (
            <p style={{ fontSize: '0.8rem', color: 'var(--sax-gray-400)', marginTop: '0.5rem', fontStyle: 'italic' }}>
              No image set — text hero is active.
            </p>
          )}
        </div>

        <div className="form-group">
          <label>Hero Subtitle</label>
          <input type="text" value={draft.heroSubtitle || ''} onChange={(e) => update('heroSubtitle', e.target.value)} />
        </div>
        <div className="form-group">
          <label>Intro Content (HTML)</label>
          <textarea value={draft.introHtml || ''} onChange={(e) => update('introHtml', e.target.value)} rows={6} />
        </div>
        <div className="form-group">
          <label>Contact Email</label>
          <input type="email" value={draft.contactEmail || ''} onChange={(e) => update('contactEmail', e.target.value)} />
        </div>
        <div className="form-group">
          <label>FAQ URL</label>
          <input type="url" value={draft.faqUrl || ''} onChange={(e) => update('faqUrl', e.target.value)} placeholder="https://..." />
        </div>
        <div className="form-group">
          <label>Site Logo</label>
          <input type="url" value={draft.logoUrl?.startsWith('data:') ? '' : (draft.logoUrl || '')} onChange={(e) => update('logoUrl', e.target.value)} placeholder="Paste image URL, or upload a file below" />
          <div style={{ marginTop: '0.5rem' }}>
            <label style={{
              display: 'inline-flex', alignItems: 'center', gap: '0.5rem',
              cursor: 'pointer', fontSize: '0.85rem', fontWeight: 500,
              color: 'var(--sax-gold-dark)', fontFamily: 'var(--font-body)'
            }}>
              <input
                type="file"
                accept=".png,.jpg,.jpeg,.svg,.gif,.webp"
                style={{ display: 'none' }}
                onChange={(e) => {
                  const file = e.target.files?.[0]
                  if (!file) return
                  const reader = new FileReader()
                  reader.onload = (ev) => update('logoUrl', ev.target.result)
                  reader.readAsDataURL(file)
                  e.target.value = ''
                }}
              />
              📁 Upload image file
            </label>
            <span style={{ fontSize: '0.75rem', color: 'var(--sax-gray-500)', marginLeft: '0.5rem' }}>
              PNG, JPG, SVG, WebP supported
            </span>
          </div>
          {draft.logoUrl && (
            <div style={{ marginTop: '0.75rem', padding: '0.75rem 1rem', background: 'var(--sax-navy)', borderRadius: 'var(--radius-md)', display: 'inline-flex', alignItems: 'center', gap: '1rem' }}>
              <img
                src={draft.logoUrl}
                alt="Logo preview"
                style={{ height: '40px', maxWidth: '240px', objectFit: 'contain', display: 'block' }}
              />
              <button
                onClick={() => update('logoUrl', '')}
                style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.5)', cursor: 'pointer', fontSize: '0.8rem' }}
              >
                Remove
              </button>
            </div>
          )}
        </div>
      </div>

      {/* Deadline & Status */}
      <div className="admin-card">
        <h3>Submission Window</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr auto', gap: '1.5rem', alignItems: 'end' }}>
          <div className="form-group">
            <label>Submission Deadline</label>
            <input
              type="datetime-local"
              value={deadlineLocal}
              onChange={(e) => {
                const val = e.target.value
                // Interpret admin input as EST/EDT (America/New_York), convert to UTC ISO
                const est = new Date(val + ':00-05:00')
                const check = est.toLocaleString('sv', { timeZone: 'America/New_York' }).replace(' ', 'T').slice(0, 16)
                const iso = check === val ? est.toISOString() : new Date(val + ':00-04:00').toISOString()
                update('submissionDeadline', iso)
              }}
            />
          </div>
          <div className="form-group">
            <div className="toggle-wrapper">
              <label className="toggle">
                <input
                  type="checkbox"
                  checked={draft.submissionsOpen || false}
                  onChange={(e) => update('submissionsOpen', e.target.checked)}
                />
                <span className="toggle__slider" />
              </label>
              <span className="toggle-label">
                {draft.submissionsOpen ? 'Submissions OPEN' : 'Submissions CLOSED'}
              </span>
            </div>
          </div>
        </div>
        <span className="helper-text">
          Deadline is in Eastern Time (EST/EDT). The form will automatically close after the deadline, or you can manually toggle it off.
        </span>
      </div>

      {/* Event Info */}
      <div className="admin-card">
        <h3>Event Details</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '1rem' }}>
          <div className="form-group">
            <label>Event Date</label>
            <input type="text" value={draft.eventDate || ''} onChange={(e) => update('eventDate', e.target.value)} />
          </div>
          <div className="form-group">
            <label>Event Time</label>
            <input type="text" value={draft.eventTime || ''} onChange={(e) => update('eventTime', e.target.value)} />
          </div>
          <div className="form-group">
            <label>Event Location</label>
            <input type="text" value={draft.eventLocation || ''} onChange={(e) => update('eventLocation', e.target.value)} />
          </div>
        </div>
      </div>

      {/* Video Questions */}
      <div className="admin-card">
        <h3>Video Submission Questions</h3>
        <div className="form-group">
          <label>Video Instructions</label>
          <textarea value={draft.videoInstructions || ''} onChange={(e) => update('videoInstructions', e.target.value)} rows={3} />
        </div>
        {draft.videoQuestions?.map((q, i) => (
          <div key={i} className="question-editor">
            <div className="question-editor__header">
              <span className="question-editor__number">Question {i + 1}</span>
              <div className="question-editor__actions">
                <button onClick={() => moveQuestion(i, -1)} title="Move up"><Icons.MoveUp /></button>
                <button onClick={() => moveQuestion(i, 1)} title="Move down"><Icons.MoveDown /></button>
                <button className="delete" onClick={() => removeQuestion(i)} title="Remove"><Icons.Trash /></button>
              </div>
            </div>
            <textarea
              value={q}
              onChange={(e) => updateQuestion(i, e.target.value)}
              rows={2}
              style={{ width: '100%', padding: '0.75rem', border: '1.5px solid var(--sax-gray-200)', borderRadius: '8px', fontFamily: 'var(--font-body)', fontSize: '0.9rem' }}
            />
          </div>
        ))}
        <button className="btn btn--outline btn--sm" onClick={addQuestion} style={{ marginTop: '0.5rem' }}>
          <Icons.Plus /> Add Question
        </button>
      </div>

      {/* Prizes */}
      <div className="admin-card">
        <h3>Prizes</h3>
        {draft.prizes?.map((p, i) => (
          <div key={i} style={{
            display: 'grid', gridTemplateColumns: '150px 1fr auto', gap: '0.75rem',
            alignItems: 'center', marginBottom: '0.75rem'
          }}>
            <input type="text" value={p.place} onChange={(e) => updatePrize(i, 'place', e.target.value)} placeholder="Place" />
            <input type="text" value={p.description} onChange={(e) => updatePrize(i, 'description', e.target.value)} placeholder="Description" />
            <button className="btn btn--outline btn--sm" onClick={() => removePrize(i)} style={{ color: 'var(--sax-red)' }}>
              <Icons.Trash />
            </button>
          </div>
        ))}
        <button className="btn btn--outline btn--sm" onClick={addPrize}>
          <Icons.Plus /> Add Prize
        </button>
      </div>

      {/* Form Fields */}
      <div className="admin-card">
        <h3>Application Form Fields</h3>
        <p style={{ fontSize: '0.85rem', color: 'var(--sax-gray-500)', marginBottom: '1rem' }}>
          Configure the text fields on the application form. File uploads (logo & video) are always included.
        </p>
        {draft.formFields?.map((field, i) => (
          <div key={i} style={{
            display: 'grid', gridTemplateColumns: '1fr 120px 80px auto', gap: '0.75rem',
            alignItems: 'center', marginBottom: '0.5rem', padding: '0.5rem',
            background: 'var(--sax-gray-100)', borderRadius: '8px'
          }}>
            <input type="text" value={field.label} onChange={(e) => updateField(i, 'label', e.target.value)} placeholder="Field label" />
            <select value={field.type} onChange={(e) => updateField(i, 'type', e.target.value)}>
              <option value="text">Text</option>
              <option value="email">Email</option>
              <option value="tel">Phone</option>
              <option value="url">URL</option>
              <option value="textarea">Textarea</option>
            </select>
            <label style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '0.8rem', cursor: 'pointer' }}>
              <input type="checkbox" checked={field.required} onChange={(e) => updateField(i, 'required', e.target.checked)} />
              Req'd
            </label>
            <button className="btn btn--outline btn--sm" onClick={() => removeField(i)} style={{ color: 'var(--sax-red)', padding: '4px 8px' }}>
              <Icons.Trash />
            </button>
          </div>
        ))}
        <button className="btn btn--outline btn--sm" onClick={addField} style={{ marginTop: '0.5rem' }}>
          <Icons.Plus /> Add Field
        </button>
      </div>

      {/* Consent Language */}
      <div className="admin-card">
        <h3>Consent Statement Language</h3>
        <p style={{ fontSize: '0.85rem', color: 'var(--sax-gray-500)', marginBottom: '1rem' }}>
          Edit the mandatory consent statements displayed on the application form.
        </p>
        <div className="form-group">
          <label>After Email — Invitation / Top 75 Statement</label>
          <textarea
            value={draft.consentTop75 || ''}
            onChange={(e) => update('consentTop75', e.target.value)}
            rows={3}
          />
        </div>
        <div className="form-group">
          <label>After Video Upload — Media Consent Statement</label>
          <textarea
            value={draft.consentVideo || ''}
            onChange={(e) => update('consentVideo', e.target.value)}
            rows={3}
          />
        </div>
        <div className="form-group">
          <label>Before Submit — C-Suite Attendance Statement</label>
          <textarea
            value={draft.consentCsuite || ''}
            onChange={(e) => update('consentCsuite', e.target.value)}
            rows={4}
          />
        </div>
      </div>

      {/* Upload Limits */}
      <div className="admin-card">
        <h3>Upload Settings</h3>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem' }}>
          <div className="form-group">
            <label>Max Video Size (MB)</label>
            <input type="number" value={draft.maxVideoSizeMB || 500} onChange={(e) => update('maxVideoSizeMB', parseInt(e.target.value))} />
          </div>
          <div className="form-group">
            <label>Max Logo Size (MB)</label>
            <input type="number" value={draft.maxLogoSizeMB || 25} onChange={(e) => update('maxLogoSizeMB', parseInt(e.target.value))} />
          </div>
          <div className="form-group">
            <label>Accepted Video Types</label>
            <input type="text" value={draft.acceptedVideoTypes || ''} onChange={(e) => update('acceptedVideoTypes', e.target.value)} />
          </div>
          <div className="form-group">
            <label>Accepted Logo Types</label>
            <input type="text" value={draft.acceptedLogoTypes || ''} onChange={(e) => update('acceptedLogoTypes', e.target.value)} />
          </div>
        </div>
      </div>

      {/* Save */}
      <div style={{ textAlign: 'right', marginTop: 'var(--space-lg)' }}>
        <button className="btn btn--primary" onClick={handleSave} disabled={saving}>
          {saving ? 'Saving...' : 'Save All Changes'}
        </button>
      </div>
    </div>
  )
}


// ===== SUBMISSIONS BROWSER =====
function SubmissionsBrowser({ submissions, onRefresh, initialSelection, onSelectionCleared }) {
  const [selected, setSelected] = useState(null)
  const [detail, setDetail] = useState(null)
  const [loading, setLoading] = useState(false)
  const [shareUrl, setShareUrl] = useState(null)
  const [deleting, setDeleting] = useState(false)

  // Handle initial selection from dashboard click
  useEffect(() => {
    if (initialSelection && !selected) {
      openSubmission(initialSelection)
      if (onSelectionCleared) onSelectionCleared()
    }
  }, [initialSelection])

  const openSubmission = async (sub) => {
    setSelected(sub)
    setLoading(true)
    try {
      const full = await getSubmission(sub.id || sub.submissionId)
      setDetail(full)
    } catch {
      setDetail(sub) // fallback to list data
    } finally {
      setLoading(false)
    }
  }

  const handleExport = async () => {
    try {
      await exportSubmissions()
    } catch (err) {
      alert('Export failed: ' + err.message)
    }
  }

  const handleDelete = async (submissionId) => {
    if (!window.confirm('Are you sure you want to delete this submission? This action cannot be undone.')) return
    setDeleting(true)
    try {
      await deleteSubmission(submissionId)
      setSelected(null)
      setDetail(null)
      if (onRefresh) onRefresh()
    } catch (err) {
      alert('Delete failed: ' + err.message)
    } finally {
      setDeleting(false)
    }
  }

  const handleShare = async (submissionId, fileType) => {
    try {
      const result = await shareSubmission(submissionId, fileType)
      setShareUrl(result.shareUrl)
    } catch (err) {
      alert('Share failed: ' + err.message)
    }
  }

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
    alert('Link copied to clipboard!')
  }

  // Detail View
  if (selected) {
    const d = detail || selected
    return (
      <div>
        <button className="back-btn" onClick={() => { setSelected(null); setDetail(null) }}>
          <Icons.ArrowLeft /> Back to All Submissions
        </button>

        <div className="admin-card">
          <div className="submission-detail__header">
            {d.logoDownloadUrl && (
              <img src={d.logoDownloadUrl} alt="Logo" className="submission-detail__logo" />
            )}
            <div className="submission-detail__info">
              <h3>{d.orgName || 'Unknown Organization'}</h3>
              <p className="submission-detail__meta">
                Submitted {d.submittedAt ? formatTimestamp(d.submittedAt) : 'N/A'}
              </p>
            </div>
          </div>

          {/* Organization Fields */}
          <h4 style={{ fontFamily: 'var(--font-display)', fontSize: '1rem', color: 'var(--sax-gold-dark)', marginBottom: '1rem' }}>
            Organization Details
          </h4>
          {['orgName', 'orgWebsite', 'orgAddress', 'orgCity', 'orgState', 'orgZip', 'orgMission', 'orgEin'].map(key => (
            d[key] ? (
              <div className="detail-field" key={key}>
                <div className="detail-field__label">{key.replace(/([A-Z])/g, ' $1').replace(/^org\s?/i, '').trim()}</div>
                <div className="detail-field__value">{d[key]}</div>
              </div>
            ) : null
          ))}

          <h4 style={{ fontFamily: 'var(--font-display)', fontSize: '1rem', color: 'var(--sax-gold-dark)', marginTop: '1.5rem', marginBottom: '1rem' }}>
            Contact Information
          </h4>
          {['contactName', 'contactTitle', 'contactEmail', 'contactPhone'].map(key => (
            d[key] ? (
              <div className="detail-field" key={key}>
                <div className="detail-field__label">{key.replace(/([A-Z])/g, ' $1').replace(/^contact\s?/i, '').trim()}</div>
                <div className="detail-field__value">
                  {key === 'contactEmail' ? <a href={`mailto:${d[key]}`}>{d[key]}</a> : d[key]}
                </div>
              </div>
            ) : null
          ))}

          <h4 style={{ fontFamily: 'var(--font-display)', fontSize: '1rem', color: 'var(--sax-gold-dark)', marginTop: '1.5rem', marginBottom: '1rem' }}>
            Executive Contact
          </h4>
          {['execName', 'execTitle', 'execEmail'].map(key => (
            d[key] ? (
              <div className="detail-field" key={key}>
                <div className="detail-field__label">{key.replace(/([A-Z])/g, ' $1').replace(/^exec\s?/i, '').trim()}</div>
                <div className="detail-field__value">
                  {key === 'execEmail' ? <a href={`mailto:${d[key]}`}>{d[key]}</a> : d[key]}
                </div>
              </div>
            ) : null
          ))}

          {/* Files */}
          <h4 style={{ fontFamily: 'var(--font-display)', fontSize: '1rem', color: 'var(--sax-gold-dark)', marginTop: '1.5rem', marginBottom: '1rem' }}>
            Uploaded Files
          </h4>
          <div style={{ display: 'grid', gap: '0.75rem' }}>
            {d.logoDownloadUrl && (
              <div style={{
                display: 'flex', alignItems: 'center', gap: '1rem', padding: '0.75rem 1rem',
                background: 'var(--sax-gray-100)', borderRadius: '8px', flexWrap: 'wrap'
              }}>
                <Icons.Image />
                <div style={{ flex: 1, minWidth: '150px' }}>
                  <div style={{ fontWeight: 600, fontSize: '0.9rem' }}>{d.logoFileName || 'logo'}</div>
                  <div style={{ fontSize: '0.8rem', color: 'var(--sax-gray-500)' }}>{d.logoFileSize ? formatFileSize(d.logoFileSize) : ''}</div>
                </div>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <a href={d.logoDownloadUrl} target="_blank" rel="noopener" className="btn btn--outline btn--sm">
                    <Icons.Download /> Download
                  </a>
                  <button className="btn btn--outline btn--sm" onClick={() => handleShare(d.id || d.submissionId, 'logo')}>
                    <Icons.Share /> Share
                  </button>
                </div>
              </div>
            )}
            {d.videoDownloadUrl && (
              <div style={{
                display: 'flex', alignItems: 'center', gap: '1rem', padding: '0.75rem 1rem',
                background: 'var(--sax-gray-100)', borderRadius: '8px', flexWrap: 'wrap'
              }}>
                <Icons.Play />
                <div style={{ flex: 1, minWidth: '150px' }}>
                  <div style={{ fontWeight: 600, fontSize: '0.9rem' }}>{d.videoFileName || 'video'}</div>
                  <div style={{ fontSize: '0.8rem', color: 'var(--sax-gray-500)' }}>{d.videoFileSize ? formatFileSize(d.videoFileSize) : ''}</div>
                </div>
                <div style={{ display: 'flex', gap: '0.5rem' }}>
                  <a href={d.videoDownloadUrl} target="_blank" rel="noopener" className="btn btn--outline btn--sm">
                    <Icons.Download /> Download
                  </a>
                  <button className="btn btn--outline btn--sm" onClick={() => handleShare(d.id || d.submissionId, 'video')}>
                    <Icons.Share /> Share
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* Share URL Modal */}
          {shareUrl && (
            <div style={{ marginTop: '1rem', padding: '1rem', background: 'var(--sax-green-light)', borderRadius: '8px', border: '1px solid var(--sax-green)' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.5rem' }}>
                <strong style={{ color: 'var(--sax-green-dark)' }}>Shareable Link (never expires)</strong>
                <button className="btn btn--outline btn--sm" onClick={() => setShareUrl(null)} style={{ padding: '2px 8px' }}>
                  &times;
                </button>
              </div>
              <div style={{ display: 'flex', gap: '0.5rem' }}>
                <input type="text" value={shareUrl} readOnly style={{ flex: 1, fontSize: '0.8rem' }} />
                <button className="btn btn--primary btn--sm" onClick={() => copyToClipboard(shareUrl)}>
                  <Icons.Copy /> Copy
                </button>
              </div>
            </div>
          )}

          {/* Metadata */}
          <div style={{ marginTop: '1.5rem', padding: '1rem', background: 'var(--sax-gray-100)', borderRadius: '8px', fontSize: '0.8rem', color: 'var(--sax-gray-500)' }}>
            <strong>Submission ID:</strong> {d.id || d.submissionId || 'N/A'}<br />
            <strong>Timestamp:</strong> {d.submittedAt || 'N/A'}<br />
            <strong>Award Year:</strong> {d.awardYear || 'N/A'}<br />
            <strong>IP Address:</strong> {d.clientIp || 'N/A'}<br />
            {d.clientInfo && (
              <>
                <strong>Browser:</strong> {d.clientInfo.userAgent || 'N/A'}<br />
                <strong>Platform:</strong> {d.clientInfo.platform || 'N/A'}<br />
                <strong>Screen:</strong> {d.clientInfo.screenSize || 'N/A'}<br />
                <strong>Timezone:</strong> {d.clientInfo.timezone || 'N/A'}
              </>
            )}
          </div>

          {/* Delete Button */}
          <div style={{ marginTop: '2rem', paddingTop: '1.5rem', borderTop: '1px solid var(--sax-gray-200)', textAlign: 'right' }}>
            <button 
              className="btn btn--outline btn--sm" 
              onClick={() => handleDelete(d.id || d.submissionId)}
              disabled={deleting}
              style={{ color: 'var(--sax-red)', borderColor: 'var(--sax-red)' }}
            >
              <Icons.Trash /> {deleting ? 'Deleting...' : 'Delete Submission'}
            </button>
          </div>
        </div>
      </div>
    )
  }

  // List View
  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'var(--space-xl)' }}>
        <h2>Submissions ({submissions.length})</h2>
        <button className="btn btn--secondary btn--sm" onClick={handleExport}>
          <Icons.Download /> Export CSV
        </button>
      </div>

      <div className="admin-card" style={{ padding: 0, overflow: 'hidden' }}>
        {submissions.length === 0 ? (
          <div style={{ padding: '3rem', textAlign: 'center', color: 'var(--sax-gray-500)' }}>
            <Icons.Folder />
            <p style={{ marginTop: '0.5rem' }}>No submissions yet.</p>
          </div>
        ) : (
          <ul className="submission-list">
            {submissions.map((s, i) => (
              <li key={i} className="submission-item" onClick={() => openSubmission(s)}>
                <span className="submission-item__org">{s.orgName || 'Unknown'}</span>
                <span className="submission-item__contact">{s.contactEmail || s.contactName || ''}</span>
                <span className="submission-item__date">{s.submittedAt ? formatTimestamp(s.submittedAt) : ''}</span>
                <span className="submission-item__arrow"><Icons.ArrowRight /></span>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  )
}


const ALLOWED_DOMAINS = ['saxtechnology.com', 'saxadvisorygroup.com']

// ===== MAIN ADMIN PAGE =====
export default function AdminPage() {
  const [user, setUser] = useState(null)
  const [authLoading, setAuthLoading] = useState(true)
  const [authError, setAuthError] = useState('')
  const [activeView, setActiveView] = useState('dashboard')
  const [config, setConfig] = useState(DEFAULT_CONFIG)
  const [submissions, setSubmissions] = useState([])
  const [toast, setToast] = useState(null)
  const [selectedSubmission, setSelectedSubmission] = useState(null)

  const showToast = (message, type = 'success') => setToast({ message, type })

  const handleLogout = () => {
    window.location.href = '/.auth/logout?post_logout_redirect_uri=/'
  }

  // Entra auth check on mount
  useEffect(() => {
    fetch('/.auth/me')
      .then(r => r.json())
      .then(data => {
        // SWA returns { clientPrincipal: {...} } in current versions;
        // fall back to legacy array format just in case
        const principal = data?.clientPrincipal ?? (Array.isArray(data) ? data[0] : null)
        if (!principal) {
          // SWA should have already enforced auth at the route level;
          // if somehow principal is missing just show sign-in button
          setAuthError('__no_principal__')
          setAuthLoading(false)
          return
        }
        const email = (principal.userDetails || '').toLowerCase()
        const domain = email.split('@')[1] || ''
        if (!ALLOWED_DOMAINS.includes(domain)) {
          setAuthError(email)
          setAuthLoading(false)
          return
        }
        setUser(principal)
        setAuthLoading(false)
      })
      .catch(() => {
        // /.auth/me unavailable (local dev) — skip auth gate
        setUser({ userDetails: 'dev@saxtechnology.com', userId: 'local' })
        setAuthLoading(false)
      })
  }, [])

  // Load data once authenticated
  useEffect(() => {
    if (!user) return
    getConfig().then(setConfig).catch(console.error)
    listSubmissions().then(setSubmissions).catch(console.error)
  }, [user])

  const handleSaveConfig = async (updatedConfig) => {
    try {
      await updateConfig(updatedConfig)
      setConfig(updatedConfig)
      showToast('Configuration saved successfully!')
    } catch (err) {
      showToast('Failed to save: ' + err.message, 'error')
    }
  }

  const refreshSubmissions = () => {
    listSubmissions().then(setSubmissions).catch(console.error)
  }

  const handleViewSubmission = (submission) => {
    setSelectedSubmission(submission)
    setActiveView('submissions')
  }

  // Loading screen
  if (authLoading) {
    return (
      <div className="login-screen">
        <div className="login-card">
          <img src="https://saxadvisorygroup.com/wp-content/uploads/2024/08/Sax_4-hor-white-5.png" alt="SAX"
            style={{ filter: 'brightness(0) saturate(100%) invert(13%) sepia(25%) saturate(1500%) hue-rotate(190deg)' }}
          />
          <h2>Verifying Access</h2>
          <p>Checking your Microsoft credentials…</p>
          <div className="spinner" style={{ margin: '1.5rem auto', width: 32, height: 32, borderWidth: 3 }} />
        </div>
      </div>
    )
  }

  // Unauthorized screen
  if (authError) {
    const isNoPrincipal = authError === '__no_principal__'
    return (
      <div className="login-screen">
        <div className="login-card">
          <img src="https://saxadvisorygroup.com/wp-content/uploads/2024/08/Sax_4-hor-white-5.png" alt="SAX"
            style={{ filter: 'brightness(0) saturate(100%) invert(13%) sepia(25%) saturate(1500%) hue-rotate(190deg)' }}
          />
          {isNoPrincipal ? (
            <>
              <h2>Admin Access</h2>
              <p>Sign in with your SAX Microsoft account to continue.</p>
              <button
                className="btn btn--primary btn--full"
                style={{ marginTop: '1.5rem' }}
                onClick={() => window.location.href = '/.auth/login/aad?post_login_redirect_uri=/admin'}
              >
                Sign in with Microsoft
              </button>
            </>
          ) : (
            <>
              <h2>Access Denied</h2>
              <p style={{ marginBottom: '0.5rem' }}>
                <strong>{authError}</strong> is not authorized to access this admin panel.
              </p>
              <p style={{ fontSize: '0.8rem', color: 'var(--sax-gray-500)', marginBottom: 0 }}>
                Only @saxtechnology.com and @saxadvisorygroup.com accounts are permitted.
              </p>
              <button
                className="btn btn--primary btn--full"
                style={{ marginTop: '1.5rem' }}
                onClick={() => window.location.href = '/.auth/logout?post_logout_redirect_uri=/'}
              >
                Sign Out
              </button>
            </>
          )}
        </div>
      </div>
    )
  }

  return (
    <div className="page-wrapper" style={{ minHeight: '100vh' }}>
      {/* Admin Header */}
      <header className="site-header">
        <div className="container" style={{ maxWidth: '100%' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <a href="/" style={{ display: 'flex', alignItems: 'center' }}>
              <img src={config.logoUrl || "https://saxadvisorygroup.com/wp-content/uploads/2024/08/Sax_4-hor-white-5.png"} alt="SAX" style={{ height: '32px', objectFit: 'contain' }} />
            </a>
            <span style={{ color: 'rgba(255,255,255,0.3)', fontSize: '1.2rem' }}>|</span>
            <span style={{ color: 'var(--sax-gold)', fontFamily: 'var(--font-display)', fontSize: '0.95rem' }}>
              Founders' Award Admin
            </span>
          </div>
          <nav className="site-header__nav">
            <span style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.78rem', marginRight: '0.25rem' }}>
              {user?.userDetails}
            </span>
            <a href="/" target="_blank" rel="noopener">
              <Icons.Eye /> View Site
            </a>
          </nav>
        </div>
      </header>

      {/* Admin Layout */}
      <div className="admin-layout">
        {/* Sidebar */}
        <nav className="admin-sidebar">
          <ul className="admin-sidebar__nav">
            <li>
              <button className={activeView === 'dashboard' ? 'active' : ''} onClick={() => setActiveView('dashboard')}>
                <Icons.Dashboard /> Dashboard
              </button>
            </li>
            <li>
              <button className={activeView === 'submissions' ? 'active' : ''} onClick={() => setActiveView('submissions')}>
                <Icons.Folder /> Submissions
              </button>
            </li>
            <li>
              <button className={activeView === 'config' ? 'active' : ''} onClick={() => setActiveView('config')}>
                <Icons.Settings /> Configuration
              </button>
            </li>
            <li style={{ marginTop: 'auto', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
              <button onClick={handleLogout}>
                <Icons.Logout /> Sign Out
              </button>
            </li>
          </ul>
        </nav>

        {/* Content */}
        <main className="admin-content">
          {activeView === 'dashboard' && (
            <DashboardView config={config} submissions={submissions} onViewSubmission={handleViewSubmission} />
          )}
          {activeView === 'config' && (
            <ConfigEditor config={config} onSave={handleSaveConfig} />
          )}
          {activeView === 'submissions' && (
            <SubmissionsBrowser 
              submissions={submissions} 
              onRefresh={refreshSubmissions}
              initialSelection={selectedSubmission}
              onSelectionCleared={() => setSelectedSubmission(null)}
            />
          )}
        </main>
      </div>

      {/* Toast */}
      {toast && <Toast {...toast} onClose={() => setToast(null)} />}
    </div>
  )
}
